
import React, { Component } from "react";
import { BrowserRouter as Router, Route,Switch,browserHistory,Redirect } from "react-router-dom";

import LoginScreen from '../pages/login/index';
import HomeScreen from '../pages/home/index';
import CallScreen from '../pages/call/index';


export default class RouterScreen extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return (
            <div style={{width:'100%',height:'100%',display:'flex'}}>
                <Router history={browserHistory}>
                    <Switch>
                        <AuthRoute exact path="/" component={LoginScreen}   history={browserHistory} />
                        {/* <Route exact path="/" component={CallScreen} /> */}
                        <AuthRoute path="/home" exact component={HomeScreen}  history={browserHistory} />
                        <Route path="/login" exact component={LoginScreen}  history={browserHistory} />
                        <Route path="/call" exact component={CallScreen}  history={browserHistory} />
                    </Switch>
                </Router>
            </div>
        );
    }
}

function AuthRoute({component:Component,...rest}){
    // const isAuth = window.localStorage.getItem('token');
    const isAuth = sessionStorage.getItem('token')
    return (
        <Route
            {...rest}
            render={props =>
                isAuth ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to="/login"
                    />
                )
            }
        />
    );
}